import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/staff/")({
  component: StaffIndex,
});

function StaffIndex() {
  // Redirect to the Today dashboard as the Staff Hub landing page
  return <Navigate to="/app/staff/today" />;
}
